<template>
    <div class="page-layout blank contacts-manage pt-3 mlr-0">
        <div class="pb-10">
            <div style="overflow-x: auto;overflow-y: hidden;">
                <div class="d-flex flex-wrap justify-content-between align-items-baseline" v-if="!is_ticket_not_found">
                    <div class="d-flex align-items-center mob-list-scroll-ticket-details" v-if="ticket_details_not_found == false">
                        <div class='slant-tabs' :class="{'activeTab':active_tab == 'details','new-blue':active_tab == 'details'}" @click="selectViewDetail('details')">
                            <span>Ticket Details</span>  
                        </div>
                        <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'email','new-blue':active_tab == 'email'}" @click="selectViewDetail('email')">
                            <span>Email</span> 
                        </div>
                        <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'comment','new-blue':active_tab == 'comment'}" @click="selectViewDetail('comment')">
                        <span>Comment</span>
                        </div>
                        <div class='slant-tabs ml-1' :class="{'activeTab':active_tab == 'activity','new-blue':active_tab == 'activity'}" @click="selectViewDetail('activity')">
                        <span>Activity</span> 
                        </div>
                    </div>
                    <div class="mt-1 d-flex align-items-center" style="gap:.5rem">
                        <span class="status-text poppins-bold-italic " >Status:</span>
                        <!-- <span class="status-text fw-600" style="font-style: italic !important;" >Status:</span>
                        <span class="status-text-custom">Status:
                        </span> -->
                        <button v-if="general_details.status" style="text-transform: capitalize;outline: none;" class="btn-smm btn-default text-white btn-success-border-radius w-100px"
                        :class="{'btn-discarded': general_details.status == 'Discard',
                        'btn-open-status-newtheme':general_details.status == 'Open',
                        'btn-assigned':general_details.status == 'Assigned',
                        'btn-unassign':general_details.status == 'Unassigned',
                        'btn-grid-inprogress-newtheme w-104px':general_details.status == 'In progress',
                        'btn-fixed-newtheme':general_details.status == 'Fixed',
                        'btn-closed-newtheme':general_details.status == 'Closed', 
                        'btn-reopen-newtheme':general_details.status == 'Re-Open',
                        'btn-rejected':general_details.status == 'Reject', 
                        'btn-schedule':general_details.status == 'Scheduled',}">
                        <hollow-dots-spinner v-if="status_loader" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#fff'" />
                           <span v-if="general_details.status == 'Re-Open'">Reopen</span>
                           <span v-else-if="general_details.status == 'In progress'">InProgress</span>
                           <span v-else> {{general_details.status == 'Discard' ? 'Discarded' : general_details.status}} </span>
                        </button>
                        <button class="btn btn-smm btn-default text-white btn-success-border-radius btn-grid-inprogress-newtheme" style="font-size:14px !important;" v-if="general_details.status == 'Closed'" @click="ticketDelete(general_details)">
                            Archive
                        </button>
                        <button class="btn-down btn-success-border-radius pointer" @click="showAllStatus()" v-if="general_details.hasOwnProperty('approve_data') && general_details.approve_data.length <= 0">
                            <i class="icon-chevron-double-down text-white" style="font-size: 20px;"></i>
                         </button>
                         <!-- <div class="status-text poppins-bold-italic" >
                            Status:
                        </div>
                        <span class="status-text fw-600" style="font-style: italic !important; font-weight:bold !important">Status:</span>
                        <div>
                            <button v-if="general_details.status" style="text-transform: capitalize;outline: none;" class="btn-smm btn-default text-white btn-success-border-radius w-100px"
                            :class="{'btn-discarded': general_details.status == 'Discard',
                            'btn-open-status-newtheme':general_details.status == 'Open',
                            'btn-assigned':general_details.status == 'Assigned',
                            'btn-unassign':general_details.status == 'Unassigned',
                            'btn-grid-inprogress-newtheme w-104px':general_details.status == 'In progress',
                            'btn-fixed-newtheme':general_details.status == 'Fixed',
                            'btn-closed-newtheme':general_details.status == 'Closed', 
                            'btn-reopen-newtheme':general_details.status == 'Re-Open',
                            'btn-rejected':general_details.status == 'Reject', 
                            'btn-schedule':general_details.status == 'Scheduled',}">
                            <hollow-dots-spinner v-if="status_loader" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#fff'" />
                            <span v-if="general_details.status == 'Re-Open'">Reopen</span>
                            <span v-else-if="general_details.status == 'In progress'">InProgress</span>
                            <span v-else> {{general_details.status == 'Discard' ? 'Discarded' : general_details.status}} </span>
                            </button>
                            <button class="btn btn-smm btn-default text-white btn-success-border-radius btn-grid-inprogress-newtheme" style="font-size:14px !important;" v-if="general_details.status == 'Closed'" @click="ticketDelete(general_details)">
                                Archive
                            </button>
                            <button class="btn-down btn-success-border-radius pointer" @click="showAllStatus()" v-if="general_details.hasOwnProperty('approve_data') && general_details.approve_data.length <= 0">
                                <i class="icon-chevron-double-down text-white" style="font-size: 20px;"></i>
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="vendor-list br-t-l-r mt-2" id="printId">
                <details-view 
                    v-if="active_tab == 'details'" @moveToEmail="moveToEmail" :showDetails="showDetails" :pagination="pagination"
                    @ticketDetailsNotFound="ticketDetailsNotFound" @previewImage="previewImage" :watch_status="watch_status"
                    :list="list" :subject="subject" :ticket_number="ticket_number" :is_ticket_not_found="is_ticket_not_found"
                    :fromApproval="approval" @passGeneralDetails="passGeneralDetails" :list_loader="list_loader">
                </details-view>
                <ticket-email v-if="active_tab == 'email'" @previewImage="previewImage" :showDetails="showDetails"></ticket-email>
                <ticket-comments 
                    v-if="active_tab == 'comment'" :is_archived="is_archived" :showDetails="showDetails"
                    @previewImage="previewImage" :subject="subject" :ticket_number="ticket_number">
                </ticket-comments>
            <ticket-activity v-if="active_tab == 'activity'" :showDetails="showDetails"></ticket-activity>
                <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
                <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></file-viewer>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <change-status @cancelStatus="cancelStatus" :template_type="template_type" @updateStatus="updateStatus" v-if="showChange" :status="ticketStatus" :closed_ticket="closed_ticket" :showDetails="showDetails"></change-status>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event.js';
import {SweetModal} from 'sweet-modal-vue';
import Swal from 'sweetalert2';
var mime = require('mime-types')
import ticket from '../mixins/ticket.js';
const DetailsView = () => import("./DetailsView");
const TicketEmail = () => import("../Tickets/TicketEmail.vue");
const TicketActivity = () => import("../Tickets/TicketActivity.vue");
const TicketComments = () => import("../Tickets/TicketComments.vue");
const Preview = () => import("../Preview");
const FileViewer = () => import("../FileViewer.vue")
const ChangeStatus = () => import("./ChangeStatus")
export default {
    mixins:[ticket],
    props:['showDetails', "is_ticket_not_found", 'watch_status','list_loader', 'pagination'],
    components:{
        Swal,
        DetailsView,
        TicketEmail,
        TicketActivity,
        TicketComments,
        Preview,
        ChangeStatus,
        SweetModal,
        FileViewer
    },
    data(){
        return{
            success_msg: '',
            show_file_viewer: false,
            doc_file_url_type: '',
            file_url_for_view:'',
            file_name_for_view: "",
            file_type_for_view: '',
            active_tab:'details',
            active_tab_body:"details",
            preview_file: '',
            preview_visible: false,
            is_software_bug: '',
            template_product_data: [],
            is_archived: false,
            ticket_details_not_found: false,
            ticket_data_id: "",
            general_details: [],
            status_loader: false,
            showChange: false,
            template_type:"",
            ajax_loader: false,
        }
    },
    methods:{
        passGeneralDetails(data){
            this.general_details = data
        },
        showAllStatus(){
            this.prop_ticket_id = this.general_details.ticket_id
            this.ticketStatus = this.general_details.status
            this.template_type = this.general_details.ticket_template
            this.closed_ticket = {
                ticket_number:this.general_details.ticket_number,
                company:this.general_details.company_name,
                subject:this.general_details.subject,
                author_name:this.general_details.created_by,
                assigned_to:this.general_details.assigned_to,
                description:this.general_details.description,
                ticket_id:this.general_details.ticket_id
            }
            this.showChange = true
        },
        ticketDelete(ticket){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to archieve" + ' ' + JSON.stringify(ticket.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id:ticket.ticket_id
                    }
                    this.confirmDelete(params)
                }
            })
        },
        async confirmDelete(params){
            try {
                this.ajax_loader = true
                let res = await this.deleteTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.ajax_loader = false
                    EventBus.$emit('RecallStatusTabs')
                    this.$emit('updateListForArchival')
                }, 3000);
            } catch (reason) {
                this.ajax_loader = false
                this.warning_msg = 'Only Closed Tickets can be Archived'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        cancelStatus(){
            this.showChange = false
        },
        updateStatus(status){
            this.showChange = false;
            this.$emit('updateStatus', status)
        },
        selectViewDetail(ticket_obj){
            if(this.ticket_details_not_found == false && !this.list_loader) {
                this.active_tab = ticket_obj
                this.active_tab_body = ticket_obj
            }
        },
        moveToEmail(){
            this.active_tab = 'email'
            this.active_tab_body = 'email'
        },
        hidePreview(){
            EventBus.$emit('ZindexChangeEnd')
            this.preview_visible = false
        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            if(this.preview_file.name.endsWith('.doc') || this.preview_file.name.endsWith('.docx') || this.preview_file.name.endsWith('.pdf') 
                || this.preview_file.name.endsWith('.ppt') || this.preview_file.name.endsWith('.pptx') || this.preview_file.name.endsWith('.txt') 
                || this.preview_file.name.endsWith('.txt') || this.preview_file.name.endsWith('.xls') || this.preview_file.name.endsWith('.xlsx') 
                || this.preview_file.name.endsWith('.xlsx') || this.preview_file.name.endsWith('.bmp') || this.preview_file.name.endsWith('.jpeg') 
                || this.preview_file.name.endsWith('.png') || this.preview_file.name.endsWith('.svg') || this.preview_file.name.endsWith('.avi') 
                || this.preview_file.name.endsWith('.mp3') || this.preview_file.name.endsWith('.mpeg') || this.preview_file.name.endsWith('.mp4')
                || this.preview_file.name.endsWith('.jpg')
            ){
                if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                    this.viewFile(this.preview_file)
                } else {
                    this.preview_visible = true;
                }
            } else {
                this.$toasted.global.error("File Format Not Supported")
            }
        },
        viewFile(file) {
            EventBus.$emit('ZindexChangeStart')
            this.file_url_for_view = file.url || "";
            this.file_name_for_view = file.name;
            this.show_file_viewer = true;
            this.file_type_for_view = file.content_type
        },
        hideFileViewer() {
            EventBus.$emit('ZindexChangeEnd')
            this.show_file_viewer = false;
        },
        ticketDetailsNotFound(data) {
            this.ticket_details_not_found = data
        }
    },
    mounted(){
        // EventBus.$on('callTicketList', () => {
        //     this.ticket_details_not_found = true
        // })
        EventBus.$on('viewDetails', (data) => {
            this.showChange = false
            this.active_tab = 'details'
            this.active_tab_body = 'details'
        })
        EventBus.$on('ticketFromFirebaseNotifyForComment', (data) => {
            if(data.active_tab == 'comments') {
                if(this.active_tab == 'comment') {
                    EventBus.$emit("ticketFromFirebaseNotify", {
                        active_tab: 'comments',
                    });
                } else {
                    this.active_tab = 'comment'
                    this.active_tab_body = 'comment'
                }
            } else if(data.active_tab == 'ticket_details') {
                this.active_tab = 'details'
                this.active_tab_body = 'details'
            }
        })
    },
    destroyed(){
        EventBus.$off('viewDetails')
    },
    watch:{
        "$route.params": function (params) {
            if(params) {
                this.active_tab = 'details'
                this.active_tab_body = 'details'
            }
        },
        'showDetails': function(params){
            this.active_tab = 'details'
            this.active_tab_body = 'details'
            this.showChange = false
        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
    }
}
</script>
<style scoped>
.status-text-custom {
    font-size: 15px;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #130e0e;
    font-style: italic;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
}
.bold-italic {
  font-style: italic;
  font-weight: bold;
}

.w-104px{
    width:104px !important;
}
    .btn-success-border-radius{
        border-radius: 4px !important;
    }
    .btn-down{
        background-color: #00448b;
        height: 32px !important;
        width: 50px;
        line-height: 32px !important;
    }
    .btn-discarded{ 
        background-image: linear-gradient(to bottom, #9fc8f4, #3883d5)  ;
        color: #130e0e !important;
    }
</style>